var exports = {
  "kL": "x28a7bf27--e9e513--container",
  "Qs": "x28a7bf27--e9e513--content",
  "Zd": "x28a7bf27--e9e513--form",
};

module.exports = exports;
